import { render, staticRenderFns } from "./refGOST2FTList.vue?vue&type=template&id=d2a7f35e"
import script from "./refGOST2FTList.vue?vue&type=script&lang=js"
export * from "./refGOST2FTList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports